import React, {PureComponent} from 'react';

interface PropsInterface {
    system: {
        id: number
    },
    disabled: boolean,
    errors: [],
    handleDetails: (state: {[key: string]: string | boolean | number}, details: string) => void
}

export default class P2PCashoutDetails extends PureComponent<PropsInterface> {
    state = {
        accept_show_wallet: true
    };

    render(): React.ReactNode {
        this.props.handleDetails(this.state, 'cashout_detail_attributes');
        return null;
    }
}
